function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }
function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
import React from 'react';
import cn from 'classnames';
import { Icon } from '../..';
import { colors } from '../../utils/colors';
import { Button } from '../../business';
export var FieldInstructions = function FieldInstructions(props) {
  var _props$open;
  var _React$useState = React.useState(false),
    _React$useState2 = _slicedToArray(_React$useState, 2),
    open = _React$useState2[0],
    setOpen = _React$useState2[1];
  var _props$position = props.position,
    position = _props$position === void 0 ? 'top-end' : _props$position;
  var toggle = function toggle(o) {
    if (props.setOpen !== undefined) {
      props.setOpen(o);
    } else {
      setOpen(o);
    }
  };
  var showCard = (_props$open = props.open) !== null && _props$open !== void 0 ? _props$open : open;
  return /*#__PURE__*/React.createElement("div", {
    className: "telia-field-instructions"
  }, /*#__PURE__*/React.createElement("div", {
    className: "telia-field-instructions--icon",
    onClick: function onClick() {
      var _props$open2;
      return toggle((_props$open2 = !props.open) !== null && _props$open2 !== void 0 ? _props$open2 : !open);
    }
  }, /*#__PURE__*/React.createElement(Icon, {
    icon: "question-circle",
    style: {
      width: '13px',
      height: '13px',
      color: colors.corePurple500
    }
  })), showCard && /*#__PURE__*/React.createElement("div", {
    className: cn('telia-field-instructions--card', "telia-field-instructions--card__".concat(position))
  }, /*#__PURE__*/React.createElement("div", {
    className: "telia-field-instructions--card--header"
  }, props.label, /*#__PURE__*/React.createElement(Button, {
    icon: "close",
    size: "compact",
    kind: "secondary-text",
    onClick: function onClick() {
      return toggle(false);
    }
  })), /*#__PURE__*/React.createElement("div", {
    className: "telia-field-instructions--card--divider"
  }), /*#__PURE__*/React.createElement("div", {
    className: "telia-field-instructions--card--body"
  }, props.description), /*#__PURE__*/React.createElement("div", {
    className: "telia-field-instructions--card--arrow"
  })));
};